import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20composition%20with%20soft%20terracotta%20orange%20and%20cream%20flowing%20shapes%2C%20elegant%20minimalist%20design%2C%20subtle%20organic%20curves%2C%20warm%20atmospheric%20background%20for%20call%20to%20action%20section&width=1800&height=800&seq=cta-bg-91media&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 to-black/55"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好让你的内容被更多人看到了吗？
        </h2>
        <p className="text-sm md:text-base text-background-300 mb-8 max-w-xl mx-auto leading-relaxed">
          加入91传媒生态体系，与5000+创作者和300+品牌一起，开启内容传播的新篇章。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            立即加入
          </Link>
          <Link
            to="/category/neirong-chuangzuo"
            className="px-7 py-3 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 text-sm md:text-base font-medium border border-background-50/25 hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}